<template>
    <div>
        
        <rkm-table
            :items="data.model.outros.permissao"
            :fields="fields"
            ref="Table"
            sort-by="descricao"
        >
            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    title="Ocupações"
                    color="primary"
                    @click="$refs.ModalPermissaoOcupacao.open(index, item)"
                    small
                >
                    <rkm-icon icon="th"/>
                </rkm-button>                    
            </template>
        </rkm-table>

        <ModalPermissaoOcupacao
            :data="data"
            ref="ModalPermissaoOcupacao"
        />
    </div>
</template>

<script>

// Mixins
import { object } from '@/mixins'

// Modal
import ModalPermissaoOcupacao from './components/ocupacao/Modal'

export default {
    components: {
        ModalPermissaoOcupacao,
    },
    computed: {
        validations() {
    
            return {}
        },
        fields() {

            return [
                { key: 'descricao', label: 'Funcionalidade', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        async validate() {

            return true
        },
    },
    mixins: [ object, ],
    props: {
        data: { type: Object, required: true, },
    }
}
    
</script>